import PropTypes from 'prop-types';
import { Box, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export const RoleAssignmentSearchToolbar = ({
  searchTerm,
  onSearchChange,
  placeholder = 'Search',
}) => (
  <Box
    sx={{
      display: 'flex',
      gap: 2,
      alignItems: 'center',
      width: '100%',
      justifyContent: 'flex-start',
    }}
  >
    <TextField
      placeholder={placeholder}
      size="small"
      variant="outlined"
      value={searchTerm}
      onChange={(e) => onSearchChange(e.target.value)}
      autoComplete="off"
      sx={{
        backgroundColor: '#fff',
        width: '300px',
        '& .MuiInputBase-input': {
          color: 'gray',
          '::placeholder': {
            color: '#b3b9c4',
            opacity: 1,
          },
        },
        '& .MuiOutlinedInput-root': {
          border: '1px solid #ccc',
          borderRadius: '10px',
          paddingRight: 0,
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon style={{ color: '#999' }} />
          </InputAdornment>
        ),
      }}
    />
  </Box>
);

RoleAssignmentSearchToolbar.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
